import React from 'react'
import { SEO } from '../../components/Seo/seo'
import { useIntl } from 'react-intl'
import { NamedRoutes } from '../../routes'
import { AuthConsumer } from '../../context/AuthContext'
import CreateInvoiceContent from '../../components/Invoice/Create'
import { FullBodyWithLogoLoader } from '../../components/Loader/FullBodyWithLogoLoader'
import InActiveUserContent from '../../components/InActiveUserContent'
import Configuration from '../../Services/Api/Configuration'
import NotAuthorize from '../../components/UnAuthorize'

const CreateInvoice = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Page.invoices.title' })}
           pathname={window.location.origin + NamedRoutes.newInvoice}
           titleTemplate={intl.formatMessage({ id: 'eInvoice' })}
           description={intl.formatMessage({ id: 'Page.invoices.title' })}
      />

      <AuthConsumer>
        {({ userDataLoading, taxpayerData, isUserActive, userPermissions }) => (
          <>
            {!!userDataLoading && <FullBodyWithLogoLoader loading={true}/>}
            {(!!Object.keys(taxpayerData).length && !!isUserActive) ?
              (!!userPermissions?.includes(Configuration.permissions.invoice.submit) ?
                <CreateInvoiceContent/>
                : <NotAuthorize/>)
              : (!userDataLoading && <InActiveUserContent/>)
            }
          </>
        )}
      </AuthConsumer>
    </>
  )
}

export default CreateInvoice
